if (!customElements.get("m-brand-list")) {
	class e extends HTMLElement {
		constructor() {
			super();
			this.handleResize = this.handleResize.bind(this); // Bind the resize handler
		}

		connectedCallback() {
			// Initialize the slider based on the current window size
			this.initSlider();

			// Add event listener for window resize
			window.addEventListener("resize", this.handleResize);
		}

		disconnectedCallback() {
			// Clean up event listener when element is removed
			window.removeEventListener("resize", this.handleResize);
		}

		handleResize() {
			// Clear the existing slider if it exists
			if (this.slider) {
				this.slider.destroy(true, true); // Destroy the existing slider instance
				this.slider = null; // Reset the slider reference
			}

			// Reinitialize the slider based on the new window size
			this.initSlider();
		}

		initSlider() {
			var desktopSlider = this.dataset.enableSlider;
			var mobileSlider = this.dataset.enableSliderMobile;

			if (desktopSlider == "true" && window.innerWidth > 768) {
				this.querySelector("[data-container]").classList.add("swiper-container", "swiper--equal-height");
				this.querySelector("[data-wrapper]").classList.add("swiper-wrapper");
				this.setupSlider();
			}

			if (mobileSlider == "true" && window.innerWidth < 768) {
				this.querySelector("[data-container]").classList.add("swiper-container", "swiper--equal-height");
				this.querySelector("[data-wrapper]").classList.add("swiper-wrapper");
				this.setupSlider();
			}
		}

		setupSlider() {
			const enableAutoplay = "true" === this.dataset.enableAutoplay;
			const autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10);
			const items = parseInt(this.dataset.items, 10);
			const swiperContainer = this.querySelector(".swiper-container");

			if (swiperContainer) {
				this.slider = new MinimogLibs.Swiper(swiperContainer, {
					slidesPerView: 1,
					slidesPerGroup: 1,
					autoplay: enableAutoplay ? { delay: 1000 * autoplaySpeed } : false,
					loop: true,
					navigation: {
						nextEl: this.querySelector(".swiper-button-next"),
						prevEl: this.querySelector(".swiper-button-prev"),
					},
					pagination: {
						el: this.querySelector(".swiper-pagination"),
						clickable: true,
					},
					breakpoints: {
						768: {
							slidesPerView: items > 3 ? 3 : items,
						},
						1024: {
							slidesPerView: items,
						},
					},
				});
			}
		}
	}

	customElements.define("m-brand-list", e);
}
